import { render, staticRenderFns } from "./register-form.vue?vue&type=template&id=6e1f4d2e"
import script from "./register-form.vue?vue&type=script&lang=js"
export * from "./register-form.vue?vue&type=script&lang=js"
import style0 from "./register-form.vue?vue&type=style&index=0&id=6e1f4d2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports